module.exports = __webpack_public_path__ + "static/img/30009 (3).5d95b6d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30009 (3).webp
// module id = EZxX
// module chunks = 14